import { IAppState } from '../../redux';
import { selectOfferGuid } from '../offer';

export const selectAnalyticsFormId = (state: IAppState): string => {
  return selectOfferGuid(state);
};
